<template>
  <div class="testv__intro__wrapper">
    <div class="testv__intro">
      <div class="sale__info">
        <div class="title"><IconLogoTestv class="logo"/><span>铁丝俱乐部</span></div>
        <div class="summary">{{ pageData.intro }}</div>
        <div class="price" v-html="priceText"></div>
      </div>
      <div class="phone__wrapper" :style="`--scale-TestIntroPhoneBox: ${this.scale};`">
        <div class="chat__wrapper">
          <div class="btns__wrapper">
            <SsButton2 :class="['btn__message', {active: active === 'intro'}]" type="text" @click="active = 'intro'">
              <IconChat class="icon__chat"/>
              <span>消息</span>
            </SsButton2>
            <SsButton2 :class="['btn__qa', {active: active === 'qa'}]" type="text" @click="active = 'qa'">
              <IconQuestion class="icon__question"/>
              <span>Q&A</span>
            </SsButton2>
          </div>
          <div class="message__wrapper custom__cursor__pointer">
            <template v-if="active === 'intro'">
              <TestvMessageItem v-for="(item, index) in messages" :key="index" :message="item"/>
            </template>
            <template v-if="active === 'qa'">
              <template v-for="(item, index) in qa">
                <TestvMessageItem :key="'q:'+index" :message="{message: item.q}" type="question" />
                <TestvMessageItem :key="'a:'+index" :message="{message: item.a}" type="answer" />
              </template>
            </template>
          </div>
          <div class="btn__join__wrapper">
            <SsButton2 class="btn__join" @click="handleJoin">
              <span>立即入会/登录</span>
            </SsButton2>
          </div>
        </div>
      </div>
      <div class="copyright">
        铁丝俱乐部由 <IconLogoTestv class="logo__testv"/> 与 <IconLogoSspai class="logo__sspai"/> 共创
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TestvMessageItem from '@/components/TestvMessageItem/index.vue'
import debounce from 'lodash/debounce'

export default {
  name: 'TestvIntro',

  components: {
    TestvMessageItem
  },

  data () {
    return {
      scale: 1,
      active: 'intro'
    }
  },

  computed: {
    ...mapState(['pageData', 'isLogin', 'terminalType']),
    price () {
      return this.$round(this.pageData.price, 2, 'number')
    },
    originalPrice () {
      return this.$round(this.pageData.originalPrice, 2, 'number')
    },
    priceText () {
      return this.pageData.priceText.replace('{{price}}', this.price).replace('{{originalPrice}}', this.originalPrice)
    },
    messages () {
      if (this.$store.state.pageData) {
        return this.$store.state.pageData.messages || []
      }
      return []
    },
    qa () {
      if (this.$store.state.pageData) {
        return this.$store.state.pageData.qa || []
      }
      return []
    }
  },

  methods: {
    resize: debounce(function () {
      const target = this.$el.querySelector('.phone__wrapper')
      const { width, height } = target.getBoundingClientRect()
      const scaleW = this.$round((width - 96) / 393, 2, 'number')
      const scaleH = this.$round((height - 72) / 852, 2, 'number')
      this.scale = Math.min(scaleW, scaleH, 1)
    }, 100),
    handleJoin () {
      const origin = process.env.NODE_ENV === 'development' ? 'https://neo.sspai.com' : window.location.origin
      const url = `${origin}/order/confirm/${this.pageData.series}?id=${this.pageData.series}&type=1`
      if (this.isLogin) {
        this.$openLink(url, '_self')
      } else {
        this.$toLogin(this, {}, true)
        window.sessionStorage.setItem('subscribe', url)
      }
    }
  },

  mounted () {
    this.resize()
    window.addEventListener('resize', this.resize)
  },

  destroyed () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.testv__intro__wrapper {
  position: relative;
  height: 100%;
  overflow: hidden;
  z-index: 4;
  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.40) 100%),url(https://cdn-static.sspai.com/page/testv/assets/bg_q40.jpeg) 50% / cover,lightgray 50% / cover no-repeat;
    z-index: 0;
  }
  .testv__intro {
    position: relative;
    width: 100vw;
    height: calc(var(--vh, 1vh) * 100);
    overflow: hidden;
    z-index: 2;
    backdrop-filter: blur(40px);
    display: flex;
    flex-direction: column;
  }
}

.phone__wrapper {
  --scale-TestIntroPhoneBox: 1;
  --inset-TestIntroPhoneBox: 8px;
  flex: 1;
  overflow: hidden;
  box-sizing: border-box;
  margin-top: auto;
  padding-bottom: 96px;
  background-image: url(https://cdn-static.sspai.com/page/testv/assets/phone_2.png);
  background-repeat: no-repeat;
  background-size: calc(1078px * var(--scale-TestIntroPhoneBox)) auto;
  max-height: calc(1100px * var(--scale-TestIntroPhoneBox));
  background-position: center top;

  @media (min-width: $screen-md) {
    --inset-TestIntroPhoneBox: 16px;
  }

  .chat__wrapper {
    width: calc(393px * var(--scale-TestIntroPhoneBox));
    height: calc(852px * var(--scale-TestIntroPhoneBox));
    margin: calc(26px * var(--scale-TestIntroPhoneBox)) auto auto;
    position: relative;
    border-radius: 33.5px;
    .message__wrapper {
      position: absolute;
      top: calc(132px * var(--scale-TestIntroPhoneBox));
      width: 100%;
      height: calc(612px * var(--scale-TestIntroPhoneBox))
      overflow: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }

    .btns__wrapper {
      position: absolute;
      width: 100%;
      height: calc(45px * var(--scale-TestIntroPhoneBox));
      top: calc(87px * var(--scale-TestIntroPhoneBox));
      display: flex;
      align-items: center;
      .btn__message,
      .btn__qa {
        display: flex;
        align-items: center;
        justify-content: center;
        width: calc(var(--scale-TestIntroPhoneBox) * 68px);
        height: calc(var(--scale-TestIntroPhoneBox) * 29px);
        column-gap: 2px;
        border-radius: 6px;
        font-size: 15px;
        font-weight: 500;
        margin-left: var(--inset-TestIntroPhoneBox);
        color: #000;
        white-space: nowrap;
        .icon__chat,
        .icon__question {
          width: 20px;
          transform: scale(var(--scale-TestIntroPhoneBox));
          transform-origin: right center;
        }
        span {
          transform: scale(var(--scale-TestIntroPhoneBox));
          transform-origin: left center;
        }
        &.active {
          background: var(--yellow-testv);
        }
      }
    }

    .btn__join__wrapper {
      position: absolute;
      width: 100%;
      height: calc(72px * var(--scale-TestIntroPhoneBox));
      bottom: calc(34px * var(--scale-TestIntroPhoneBox));
      display: flex;
      align-items: center;
      white-space: nowrap;
      .btn__join {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 var(--inset-TestIntroPhoneBox);
        background: var(--yellow-testv);
        flex: 1;
        height: calc(40px * var(--scale-TestIntroPhoneBox));
        border-radius: 8px;
        color: #000;
        font-size: 17px;
        font-weight: 500;
        span {
          transform: scale(var(--scale-TestIntroPhoneBox));
        }
      }
    }
  }
}

.sale__info {
  padding: 16px;
  margin-top: auto;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 8px;
    color: #fff;
    font-size: 17px;
    font-weight: 500;
    .logo {
      width: 120px;
    }
  }
  .summary {
    font-size: 15px;
    color: #fff;
    opacity: 0.6;
    margin: 8px auto;
    text-align: center;
  }
  .price {
    font-size: 15px;
    line-height: 21px;
    text-align: center;
    white-space: pre-wrap;
    color: #fff9;
    >>> span {
      font-size: 24px;
      font-weight: 500;
      font-family: 'Outfit-Medium';
      color: var(--yellow-testv);
    }
    >>> del {
      margin-left: 4px;
    }
    @media (min-width: $screen-md) {
      white-space: nowrap;
    }
  }
}

.copyright {
  position: absolute;
  bottom: 0px;
  z-index: 2;
  padding: 12px;
  // padding-bottom: calc(12px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 8px;
  opacity: 0.5;
  font-size: 13px;
  .logo__testv {
    height: 12px;
  }
  .logo__sspai {
    height: 16px;
  }
}
</style>
